import { IconStock } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

export const stockModule: ModuleDefinition = {
  id: 'stock',
  i18nNamespace: 'stock',
  requires: { subject: 'stock', action: 'read' },

  nav: {
    labelKey: 'stock:nav',
    icon: IconStock,
    to: 'stock',
    group: 'move',
    order: 30,
  },

  routes: [{ path: 'stock', component: () => import('./StockPage') }],

  commands: [
    {
      id: 'stock.count',
      labelKey: 'stock:count',
      groupKey: 'stock:title',
      requires: { subject: 'stock', action: 'update' },
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/stock?count=1`),
    },
  ],
};
